import { Resource, ResourceKey } from 'i18next'
import { merge } from 'lodash'
import { deComponentLibraryBannerComponents } from '../../../i18n/locales/de/ComponentLibrary/src/molecules/AppBar/Banner'
import { deClientPortalErrorHandlersErrors } from '../../../i18n/locales/de/ClientPortal/ErrorHandling/errorHandlers'
import { deCommon } from '../../../i18n/locales/de/Shared/terminology'
import { deClientPortalAnalysisPages } from '../../../i18n/locales/de/ClientPortal/pages/Analysis'
import { deClientPortalAuthenticatedAppPages } from '../../../i18n/locales/de/ClientPortal/pages/AuthenticatedApp'
import { deClientPortalAssetsCommon } from '../../../i18n/locales/de/ClientPortal/pages/Assets'
import { deClientPortalDashboardPages } from '../../../i18n/locales/de/ClientPortal/pages/Dashboard'
import { deClientPortalErrorPagePages } from '../../../i18n/locales/de/ClientPortal/pages/ErrorPage'
import { deClientPortalLayoutPages } from '../../../i18n/locales/de/ClientPortal/pages/Layout'
import { deClientPortalMarketDataPages } from '../../../i18n/locales/de/ClientPortal/pages/MarketData'
import { deClientPortalOrdersPages } from '../../../i18n/locales/de/ClientPortal/pages/Orders'
import { deClientPortalPlaygroundPages } from '../../../i18n/locales/de/ClientPortal/pages/Playground'
import { deClientPortalSettingsPages } from '../../../i18n/locales/de/ClientPortal/pages/Settings'
import { deClientPortalUserSettingsPageValidation } from '../../../i18n/locales/de/ClientPortal/pages/Settings/UserSettingsPage'
import { deClientPortalTaskSideDrawerPages } from '../../../i18n/locales/de/ClientPortal/pages/TaskSideDrawer'
import { deClientPortalTaskOverviewPagePages } from '../../../i18n/locales/de/ClientPortal/pages/TaskOverviewPage'
import { deClientPortalThreadOverviewPagePages } from '../../../i18n/locales/de/ClientPortal/pages/ThreadOverviewPage'
import { enClientPortalErrorHandlersErrors } from '../../../i18n/locales/en/ClientPortal/ErrorHandling/errorHandlers'
import { enComponentLibraryBannerComponents } from '../../../i18n/locales/en/ComponentLibrary/src/molecules/AppBar/Banner'
import { enCommon } from '../../../i18n/locales/en/ClientPortal/terminology'
import { enClientPortalAnalysisPages } from '../../../i18n/locales/en/ClientPortal/pages/Analysis'
import { enClientPortalAuthenticatedAppPages } from '../../../i18n/locales/en/ClientPortal/pages/AuthenticatedApp'
import { enClientPortalAssetsCommon } from '../../../i18n/locales/en/ClientPortal/pages/Assets'
import { enClientPortalDashboardPages } from '../../../i18n/locales/en/ClientPortal/pages/Dashboard'
import { enClientPortalErrorPagePages } from '../../../i18n/locales/en/ClientPortal/pages/ErrorPage'
import { enClientPortalLayoutPages } from '../../../i18n/locales/en/ClientPortal/pages/Layout'
import { enClientPortalMarketDataPages } from '../../../i18n/locales/en/ClientPortal/pages/MarketData'
import { enClientPortalOrdersPages } from '../../../i18n/locales/en/ClientPortal/pages/Orders'
import { enClientPortalPlaygroundPages } from '../../../i18n/locales/en/ClientPortal/pages/Playground'
import { enClientPortalSettingsPages } from '../../../i18n/locales/en/ClientPortal/pages/Settings'
import { enClientPortalUserSettingsPageValidation } from '../../../i18n/locales/en/ClientPortal/pages/Settings/UserSettingsPage'
import { enClientPortalTaskSideDrawerPages } from '../../../i18n/locales/en/ClientPortal/pages/TaskSideDrawer'
import { enClientPortalTaskOverviewPagePages } from '../../../i18n/locales/en/ClientPortal/pages/TaskOverviewPage'
import { enClientPortalThreadOverviewPagePages } from '../../../i18n/locales/en/ClientPortal/pages/ThreadOverviewPage'

function mergeResourceKeys(...resourceKeys: ResourceKey[]) {
    return merge({}, ...resourceKeys)
}

export const bundledResources = {
    'de-DE': {
        terminology: mergeResourceKeys(deCommon),
        components: mergeResourceKeys(deComponentLibraryBannerComponents),
        pages: mergeResourceKeys(
            deClientPortalAuthenticatedAppPages,
            deClientPortalLayoutPages,
            deClientPortalSettingsPages,
            deClientPortalAssetsCommon,
            deClientPortalDashboardPages,
            deClientPortalOrdersPages,
            deClientPortalPlaygroundPages,
            deClientPortalTaskOverviewPagePages,
            deClientPortalTaskSideDrawerPages,
            deClientPortalThreadOverviewPagePages,
            deClientPortalDashboardPages,
            deClientPortalAnalysisPages,
            deClientPortalErrorPagePages,
            deClientPortalMarketDataPages
        ),
        errors: mergeResourceKeys(deClientPortalErrorHandlersErrors),
        validation: mergeResourceKeys(deClientPortalUserSettingsPageValidation),
    },
    'en-US': {
        terminology: mergeResourceKeys(enCommon),
        components: mergeResourceKeys(enComponentLibraryBannerComponents),
        pages: mergeResourceKeys(
            enClientPortalAuthenticatedAppPages,
            enClientPortalLayoutPages,
            enClientPortalSettingsPages,
            enClientPortalAssetsCommon,
            enClientPortalDashboardPages,
            enClientPortalOrdersPages,
            enClientPortalPlaygroundPages,
            enClientPortalTaskOverviewPagePages,
            enClientPortalTaskSideDrawerPages,
            enClientPortalThreadOverviewPagePages,
            enClientPortalDashboardPages,
            enClientPortalAnalysisPages,
            enClientPortalErrorPagePages,
            enClientPortalMarketDataPages
        ),
        errors: mergeResourceKeys(enClientPortalErrorHandlersErrors),
        validation: mergeResourceKeys(enClientPortalUserSettingsPageValidation),
    },
} satisfies Resource
